import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Rajesh Kumar",
    qualification: "MBBS, MS - Urology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Varicocele Specialist"
  },
  {
    name: "Dr. Anil Sharma",
    qualification: "MBBS, MCh - Urology",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Male Infertility Expert"
  },
  {
    name: "Dr. Vikram Singh",
    qualification: "MBBS, MS - General Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Microsurgical Varicocelectomy"
  },
  {
    name: "Dr. Sanjay Reddy",
    qualification: "MBBS, MD - Reproductive Medicine",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Fertility Preservation Expert"
  },
  {
    name: "Dr. Arun Patel",
    qualification: "MBBS, MS - Urology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Varicocele Treatment"
  },
  {
    name: "Dr. Mohan Das",
    qualification: "MBBS, MCh - Urology",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Laparoscopic Surgery Expert"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Varicocele Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert care for comprehensive varicocele treatment with advanced surgical techniques and fertility improvement.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const VaricoceleTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Varicocele Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Comprehensive Surgical Solutions with 90% Success Rate. Specialized Care for Male Fertility and Pain Relief.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Fertility Improvement Options
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15-20%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Men Affected Worldwide</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>90%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Treatment Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>60%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Fertility Improvement</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>40%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Male Infertility Cases</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "grades", label: "Grades", icon: "🎯" },
              { id: "diagnosis", label: "Diagnosis", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "fertility", label: "Fertility", icon: "🔄" },
              { id: "recovery", label: "Recovery", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Varicocele Treatment</span>
            </h2>
          </div>

          {/* What is Varicocele */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Varicocele
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                A varicocele is an enlargement of the veins within the scrotum, similar to varicose veins that occur in the legs. 
                These veins are part of the pampiniform plexus that drain blood from the testicles. When the valves in these veins 
                don't work properly, blood pools, causing the veins to dilate and become varicose.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Common Locations</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      85-90% occur on the left side due to anatomical factors. Bilateral varicoceles occur in 10-15% of cases, 
                      while isolated right-sided varicoceles are rare and may indicate other underlying conditions.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Age Groups Affected</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Most commonly diagnosed in adolescents and young adults aged 15-25 years. Prevalence increases with age 
                      and is found in approximately 40% of men evaluated for infertility.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Detailed Symptoms */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Symptoms Guide
            </h3>

            <div className="row">
              {[
                {
                  title: "Scrotal Pain & Discomfort", 
                  description: "Dull, aching pain or heaviness in scrotum that worsens through the day or with physical activity",
                  details: "Most common symptom, often described as 'bag of worms' sensation"
                },
                {
                  title: "Visible Vein Enlargement", 
                  description: "Enlarged, twisted veins visible through scrotal skin, especially when standing",
                  details: "Veins may feel like a bag of worms when palpated"
                },
                {
                  title: "Testicular Atrophy", 
                  description: "Shrinkage of affected testicle due to impaired blood flow and increased temperature",
                  details: "More common in adolescents with varicocele"
                },
                {
                  title: "Fertility Issues", 
                  description: "Reduced sperm count, decreased sperm motility, and abnormal sperm morphology",
                  details: "Leading correctable cause of male infertility"
                },
                {
                  title: "Worsening with Standing", 
                  description: "Symptoms intensify when standing for long periods and improve when lying down",
                  details: "Due to gravitational pressure on veins"
                },
                {
                  title: "Asymptomatic Cases", 
                  description: "Many men have no symptoms and varicocele is discovered during fertility evaluation",
                  details: "Regular check-ups important for early detection"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Varicocele Grades */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Varicocele Classification & Grades
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Grade I (Small)",
                    description: "Palpable only during Valsalva maneuver (bearing down), not visible. Smallest clinical grade.",
                    treatment: "Observation, lifestyle modifications, scrotal support"
                  },
                  {
                    type: "Grade II (Moderate)",
                    description: "Palpable without Valsalva maneuver but not visible. Moderate enlargement of veins.",
                    treatment: "Consider treatment if symptomatic or affecting fertility"
                  },
                  {
                    type: "Grade III (Large)",
                    description: "Visible and palpable through scrotal skin without Valsalva. 'Bag of worms' appearance.",
                    treatment: "Surgical intervention recommended in most cases"
                  },
                  {
                    type: "Subclinical",
                    description: "Not palpable or visible but detected only by Doppler ultrasound. No clinical significance.",
                    treatment: "Usually no treatment required"
                  },
                  {
                    type: "Bilateral",
                    description: "Varicoceles present on both sides. Associated with more severe fertility issues.",
                    treatment: "Bilateral surgical repair often recommended"
                  },
                  {
                    type: "Recurrent",
                    description: "Varicocele that reappears after previous surgical treatment. Requires specialized approach.",
                    treatment: "Microsurgical re-exploration or embolization"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes and Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Primary Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Faulty valves in spermatic veins</li>
                      <li style={{ marginBottom: "10px" }}>Anatomical differences in left vs right testicular veins</li>
                      <li style={{ marginBottom: "10px" }}>Compression of renal vein between aorta and SMA</li>
                      <li style={{ marginBottom: "10px" }}>Increased venous pressure in testicular veins</li>
                      <li>Genetic predisposition and family history</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Age (15-25 years most common)</li>
                      <li style={{ marginBottom: "10px" }}>Tall height and rapid growth during puberty</li>
                      <li style={{ marginBottom: "10px" }}>Family history of varicoceles</li>
                      <li style={{ marginBottom: "10px" }}>Occupations requiring prolonged standing</li>
                      <li>Obesity and sedentary lifestyle</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Conservative Management
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Non-surgical approaches are often recommended for mild, asymptomatic varicoceles or as initial 
                    management while monitoring progression. These methods focus on symptom relief and prevention of worsening.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Lifestyle Modifications:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Scrotal support (athletic supporter)</li>
                          <li style={{ marginBottom: "8px" }}>Avoid prolonged standing</li>
                          <li style={{ marginBottom: "8px" }}>Regular exercise with proper support</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Ice packs for pain relief</li>
                          <li style={{ marginBottom: "8px" }}>Over-the-counter pain medications</li>
                          <li style={{ marginBottom: "8px" }}>Weight management</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Monitoring & Follow-up:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Regular physical examinations</li>
                      <li style={{ marginBottom: "8px" }}>Annual testicular ultrasound</li>
                      <li style={{ marginBottom: "8px" }}>Semen analysis for fertility concerns</li>
                      <li>Testicular volume measurements</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Treatment Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Microsurgical Varicocelectomy:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Gold standard with highest success rates</li>
                      <li style={{ marginBottom: "10px" }}>Performed under operating microscope</li>
                      <li style={{ marginBottom: "10px" }}>Preserves testicular artery and lymphatics</li>
                      <li style={{ marginBottom: "10px" }}>Lowest recurrence and complication rates</li>
                      <li>Outpatient procedure with local anesthesia</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Other Surgical Approaches:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Laparoscopic varicocelectomy</li>
                      <li style={{ marginBottom: "10px" }}>Radiographic embolization</li>
                      <li style={{ marginBottom: "10px" }}>Open surgical approaches (Ivanissevich, Palomo)</li>
                      <li style={{ marginBottom: "10px" }}>Robotic-assisted microsurgery</li>
                      <li>Percutaneous sclerotherapy</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Outcomes:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>90-95% success rate with microsurgery</li>
                      <li style={{ marginBottom: "10px" }}>60-80% improvement in semen parameters</li>
                      <li>40-60% natural pregnancy rate post-surgery</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Fertility and Varicocele */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Fertility Improvement & Treatment Outcomes
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Before Treatment",
                    title: "Baseline Evaluation",
                    activities: ["Semen analysis", "Hormone testing", "Testicular ultrasound", "Fertility assessment"]
                  },
                  {
                    period: "3-6 Months Post-op",
                    title: "Initial Improvement",
                    activities: ["Improved sperm count", "Better motility", "Reduced DNA fragmentation", "Hormonal balance"]
                  },
                  {
                    period: "6-12 Months",
                    title: "Optimal Results",
                    activities: ["Peak semen parameters", "Maximum fertility potential", "Natural conception possible", "IVF success improved"]
                  },
                  {
                    period: "Long-term",
                    title: "Maintenance",
                    activities: ["Sustained improvements", "Regular follow-up", "Lifestyle maintenance", "Fertility preservation"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Recovery and Long-term Management */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Recovery & Long-term Management
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Post-Surgical Recovery</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>2-3 days of rest and limited activity</li>
                      <li style={{ marginBottom: "10px" }}>1-2 weeks before returning to work</li>
                      <li style={{ marginBottom: "10px" }}>4-6 weeks before strenuous exercise</li>
                      <li>Gradual improvement in symptoms over 2-4 weeks</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Follow-up</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Regular semen analysis every 3-6 months</li>
                      <li style={{ marginBottom: "10px" }}>Annual testicular examinations</li>
                      <li style={{ marginBottom: "10px" }}>Monitoring for recurrence</li>
                      <li>Fertility tracking and family planning</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Can varicocele affect fertility and how?",
                  answer: "Yes, varicocele is the most common correctable cause of male infertility, affecting approximately 40% of men with primary infertility and 80% with secondary infertility. It impacts fertility through several mechanisms: increased scrotal temperature impairs sperm production; blood backflow introduces toxins and reactive oxygen species that damage sperm; hormonal imbalances affect sperm maturation; and testicular hypoxia reduces sperm quality. The good news is that surgical treatment can significantly improve semen parameters in 60-80% of men and increase natural pregnancy rates by 40-60%. The degree of improvement depends on factors like varicocele size, duration, and baseline semen quality."
                },
                {
                  question: "What's the success rate of varicocele surgery?",
                  answer: "Microsurgical varicocelectomy has the highest success rates among all treatment options, with 90-95% technical success in eliminating the varicocele. In terms of outcomes: Pain relief is achieved in 85-90% of symptomatic patients; Semen parameters improve in 60-80% of cases; Natural pregnancy rates increase by 40-60%; Testicular catch-up growth occurs in 80-90% of adolescents. Success rates vary based on surgical technique, with microsurgery showing superior results compared to other approaches. The recurrence rate is less than 2% with microsurgery, compared to 5-15% with other techniques. Proper patient selection and surgical expertise are crucial for optimal outcomes."
                },
                {
                  question: "When is varicocele treatment necessary?",
                  answer: "Varicocele treatment is recommended in several specific situations: For adolescents with progressive testicular atrophy (size difference >2ml or >20%); In men with palpable varicocele and abnormal semen parameters who are attempting conception; For symptomatic varicoceles causing significant pain or discomfort affecting quality of life; In cases of bilateral varicoceles regardless of symptoms; When varicocele is associated with hormonal abnormalities. For asymptomatic men with normal semen analysis and no testicular atrophy, observation may be appropriate. The decision should be made through shared decision-making between patient and urologist, considering individual circumstances, fertility goals, and symptom severity."
                },
                {
                  question: "What's the difference between microsurgery and other varicocele treatments?",
                  answer: "Microsurgical varicocelectomy is considered the gold standard because it offers several advantages: It uses an operating microscope for precise identification and preservation of testicular arteries, lymphatics, and nerves; It has the lowest recurrence rate (<2%) compared to laparoscopic (5-10%) or radiographic approaches (10-25%); It results in fewer complications like hydrocele formation (1% vs 5-8% with other techniques); It allows for complete ligation of all venous channels. Other approaches include laparoscopic surgery (minimally invasive but higher recurrence), embolization (non-surgical but radiation exposure), and open techniques (higher complication rates). Microsurgery provides the best balance of efficacy, safety, and fertility outcomes, though it requires specialized training and equipment."
                },
                {
                  question: "Can varicocele recur after treatment?",
                  answer: "Yes, varicocele can recur after treatment, though recurrence rates vary significantly by treatment method. Microsurgical varicocelectomy has the lowest recurrence rate of less than 2%, while laparoscopic approaches have 5-10% recurrence, and radiographic embolization has 10-25% recurrence. Recurrence typically happens due to missed venous channels during surgery, collateral vein development, or technical failures. Symptoms of recurrence include return of scrotal heaviness, visible vein enlargement, or persistent fertility issues. If recurrence occurs, microsurgical re-exploration is usually recommended as it can successfully treat most recurrent varicoceles. Regular follow-up with physical examination and ultrasound can detect recurrence early, allowing for prompt management if needed."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready to Address Your Varicocele?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert urology team provides comprehensive varicocele treatment with advanced microsurgical techniques.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Urology Consultations: <strong>080-6541-7705</strong> | Male Fertility: <strong>080-6541-7711</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default VaricoceleTreatment;